/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  PortfolioTransactionBulkCreateDataRequest
} from '../../model/portfolioTransactionBulkCreateDataRequest'
import type {
  PortfolioTransactionGetFundFamilyEventResponse
} from '../../model/portfolioTransactionGetFundFamilyEventResponse'
import type {
  PortfolioTransactionListAdjustmentsTableParams
} from '../../model/portfolioTransactionListAdjustmentsTableParams'
import type {
  PortfolioTransactionListParams
} from '../../model/portfolioTransactionListParams'
import type {
  PortfolioTransactionReadDataList
} from '../../model/portfolioTransactionReadDataList'
import type {
  PortfolioTransactionReadOnlyTableRetriveParams
} from '../../model/portfolioTransactionReadOnlyTableRetriveParams'
import type {
  PortfolioTransactionUpsertFeeEventParams
} from '../../model/portfolioTransactionUpsertFeeEventParams'
import type {
  PortfolioTransactionUpsertParams
} from '../../model/portfolioTransactionUpsertParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Returns table data of allocation of portfolio transactions with adjustments.
 */
export const portfolioTransactionListAdjustmentsTable = (
    fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/adjustments-table`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPortfolioTransactionListAdjustmentsTableQueryKey = (fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams,) => {
    return [`/fund-family/${fundFamilyId}/portfolio-transactions/adjustments-table`, ...(params ? [params]: [])] as const;
    }

    
export const getPortfolioTransactionListAdjustmentsTableQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionListAdjustmentsTableQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>> = ({ signal }) => portfolioTransactionListAdjustmentsTable(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionListAdjustmentsTableQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>>
export type PortfolioTransactionListAdjustmentsTableQueryError = unknown

export const usePortfolioTransactionListAdjustmentsTable = <TData = Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionListAdjustmentsTableQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPortfolioTransactionListAdjustmentsTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionListAdjustmentsTableQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>> = ({ signal }) => portfolioTransactionListAdjustmentsTable(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionListAdjustmentsTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>>
export type PortfolioTransactionListAdjustmentsTableSuspenseQueryError = unknown

export const usePortfolioTransactionListAdjustmentsTableSuspense = <TData = Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionListAdjustmentsTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionListAdjustmentsTable>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionListAdjustmentsTableSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getPortfolioTransactionListAdjustmentsTableLoader = (queryParamsOrFn?: (PortfolioTransactionListAdjustmentsTableParams | ((params: Params) => PortfolioTransactionListAdjustmentsTableParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getPortfolioTransactionListAdjustmentsTableQueryKey(fundFamilyId, queryParams),
              queryFn: () => portfolioTransactionListAdjustmentsTable(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get pending portfolio tx posting
 */
export const getDraftPortfolioEvent = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PortfolioTransactionGetFundFamilyEventResponse>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/event/view`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDraftPortfolioEventQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/portfolio-transactions/event/view`] as const;
    }

    
export const getGetDraftPortfolioEventQueryOptions = <TData = Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftPortfolioEventQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftPortfolioEvent>>> = ({ signal }) => getDraftPortfolioEvent(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftPortfolioEventQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftPortfolioEvent>>>
export type GetDraftPortfolioEventQueryError = unknown

export const useGetDraftPortfolioEvent = <TData = Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDraftPortfolioEventQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDraftPortfolioEventSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftPortfolioEventQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftPortfolioEvent>>> = ({ signal }) => getDraftPortfolioEvent(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftPortfolioEventSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftPortfolioEvent>>>
export type GetDraftPortfolioEventSuspenseQueryError = unknown

export const useGetDraftPortfolioEventSuspense = <TData = Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDraftPortfolioEvent>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDraftPortfolioEventSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getGetDraftPortfolioEventLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getGetDraftPortfolioEventQueryKey(fundFamilyId),
              queryFn: () => getDraftPortfolioEvent(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns a list of portfolio transactions for a fund family event.
 */
export const portfolioTransactionList = (
    fundFamilyId: string,
    params?: PortfolioTransactionListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PortfolioTransactionReadDataList>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/upsert`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPortfolioTransactionListQueryKey = (fundFamilyId: string,
    params?: PortfolioTransactionListParams,) => {
    return [`/fund-family/${fundFamilyId}/portfolio-transactions/upsert`, ...(params ? [params]: [])] as const;
    }

    
export const getPortfolioTransactionListQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionList>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionList>>> = ({ signal }) => portfolioTransactionList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionListQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionList>>>
export type PortfolioTransactionListQueryError = unknown

export const usePortfolioTransactionList = <TData = Awaited<ReturnType<typeof portfolioTransactionList>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPortfolioTransactionListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionList>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionList>>> = ({ signal }) => portfolioTransactionList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionList>>>
export type PortfolioTransactionListSuspenseQueryError = unknown

export const usePortfolioTransactionListSuspense = <TData = Awaited<ReturnType<typeof portfolioTransactionList>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getPortfolioTransactionListLoader = (queryParamsOrFn?: (PortfolioTransactionListParams | ((params: Params) => PortfolioTransactionListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getPortfolioTransactionListQueryKey(fundFamilyId, queryParams),
              queryFn: () => portfolioTransactionList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upsert portfolio transactions for a fund family event.
 */
export const portfolioTransactionUpsertFeeEvent = (
    fundFamilyId: string,
    portfolioTransactionBulkCreateDataRequest: PortfolioTransactionBulkCreateDataRequest,
    params?: PortfolioTransactionUpsertFeeEventParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portfolioTransactionBulkCreateDataRequest,
        params
    },
      options);
    }
  


export const getPortfolioTransactionUpsertFeeEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsertFeeEvent>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertFeeEventParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsertFeeEvent>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertFeeEventParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioTransactionUpsertFeeEvent>>, {fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertFeeEventParams}> = (props) => {
          const {fundFamilyId,data,params} = props ?? {};

          return  portfolioTransactionUpsertFeeEvent(fundFamilyId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PortfolioTransactionUpsertFeeEventMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionUpsertFeeEvent>>>
    export type PortfolioTransactionUpsertFeeEventMutationBody = PortfolioTransactionBulkCreateDataRequest
    export type PortfolioTransactionUpsertFeeEventMutationError = unknown

    export const usePortfolioTransactionUpsertFeeEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsertFeeEvent>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertFeeEventParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getPortfolioTransactionUpsertFeeEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a table with portfolio transactions for the query parameters.
 */
export const portfolioTransactionReadOnlyTableRetrive = (
    fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/view`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPortfolioTransactionReadOnlyTableRetriveQueryKey = (fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams,) => {
    return [`/fund-family/${fundFamilyId}/portfolio-transactions/view`, ...(params ? [params]: [])] as const;
    }

    
export const getPortfolioTransactionReadOnlyTableRetriveQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionReadOnlyTableRetriveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>> = ({ signal }) => portfolioTransactionReadOnlyTableRetrive(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionReadOnlyTableRetriveQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>>
export type PortfolioTransactionReadOnlyTableRetriveQueryError = unknown

export const usePortfolioTransactionReadOnlyTableRetrive = <TData = Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionReadOnlyTableRetriveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPortfolioTransactionReadOnlyTableRetriveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError = unknown>(fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPortfolioTransactionReadOnlyTableRetriveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>> = ({ signal }) => portfolioTransactionReadOnlyTableRetrive(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData> & { queryKey: QueryKey }
}

export type PortfolioTransactionReadOnlyTableRetriveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>>
export type PortfolioTransactionReadOnlyTableRetriveSuspenseQueryError = unknown

export const usePortfolioTransactionReadOnlyTableRetriveSuspense = <TData = Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError = unknown>(
 fundFamilyId: string,
    params?: PortfolioTransactionReadOnlyTableRetriveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof portfolioTransactionReadOnlyTableRetrive>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPortfolioTransactionReadOnlyTableRetriveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getPortfolioTransactionReadOnlyTableRetriveLoader = (queryParamsOrFn?: (PortfolioTransactionReadOnlyTableRetriveParams | ((params: Params) => PortfolioTransactionReadOnlyTableRetriveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getPortfolioTransactionReadOnlyTableRetriveQueryKey(fundFamilyId, queryParams),
              queryFn: () => portfolioTransactionReadOnlyTableRetrive(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts portfolio transactions with a new fund family event for posting portfolio transactions
 */
export const portfolioTransactionUpsert = (
    fundFamilyId: string,
    portfolioTransactionBulkCreateDataRequest: PortfolioTransactionBulkCreateDataRequest,
    params?: PortfolioTransactionUpsertParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/portfolio-transactions/view`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portfolioTransactionBulkCreateDataRequest,
        params
    },
      options);
    }
  


export const getPortfolioTransactionUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsert>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsert>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioTransactionUpsert>>, {fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertParams}> = (props) => {
          const {fundFamilyId,data,params} = props ?? {};

          return  portfolioTransactionUpsert(fundFamilyId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PortfolioTransactionUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionUpsert>>>
    export type PortfolioTransactionUpsertMutationBody = PortfolioTransactionBulkCreateDataRequest
    export type PortfolioTransactionUpsertMutationError = unknown

    export const usePortfolioTransactionUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionUpsert>>, TError,{fundFamilyId: string;data: PortfolioTransactionBulkCreateDataRequest;params?: PortfolioTransactionUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getPortfolioTransactionUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    